module.exports = __webpack_public_path__ + "static/security-hero-0e7037709ac807fde485359ade0ccc29.png";